import { render, staticRenderFns } from "./clienteVer.vue?vue&type=template&id=41d73267&scoped=true&"
import script from "./clienteVer.vue?vue&type=script&lang=js&"
export * from "./clienteVer.vue?vue&type=script&lang=js&"
import style0 from "./clienteVer.vue?vue&type=style&index=0&id=41d73267&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d73267",
  null
  
)

export default component.exports